import { useContext } from "react"
import { ExtratoPixFornecedorContext } from "./ExtratoPixFornecedorContext"

export function useExtratoPixFornecedorContext() {
    return useContext(ExtratoPixFornecedorContext)
}
